import React from "react"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Dialog from "@material-ui/core/Dialog"
import DialogBody from "./dialogBody"

const useStyles = makeStyles(theme => ({
  backdrop: {
    backgroundColor: 'rgba(255, 255, 255, 0.9)'
  },
}))

export default props => {
  const classes = useStyles()
  const theme = useTheme()
  const {
    xs, sm, md, lg, xl,
    fullScreen,
    onClose,
    titleId,
    maxWidth,
    PaperComponent,
    PaperProps,
    BackdropProps,
    showCloseButton,
    ...otherProps} = props
  const sizes = {xs, sm, md, lg, xl}
  const breakpoint = fullScreen !== true && fullScreen
  var isFullScreen = useMediaQuery(theme.breakpoints.down(breakpoint || 0))
  isFullScreen = fullScreen === true ? fullScreen : isFullScreen

  return (
    <Dialog
      aria-labelledby={props.titleId}
      maxWidth={false}
      PaperComponent={DialogBody}
      PaperProps={{...sizes, fullScreen: isFullScreen, onClose: showCloseButton && onClose}}
      BackdropProps={{classes: {root: classes.backdrop}}}
      fullScreen={isFullScreen}
      {...otherProps}
    >
      {props.children}
    </Dialog>
  )
}
